import { render, staticRenderFns } from "./u-dropdown-item.vue?vue&type=template&id=4d399517&scoped=true&"
import script from "./u-dropdown-item.vue?vue&type=script&lang=js&"
export * from "./u-dropdown-item.vue?vue&type=script&lang=js&"
import style0 from "./u-dropdown-item.vue?vue&type=style&index=0&id=4d399517&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d399517",
  null
  
)

component.options.__file = "node_modules/uview-ui/components/u-dropdown-item/u-dropdown-item.vue"
export default component.exports